import { BarChart3 } from "lucide-react";
import AdminPageHeader from "@/components/layout/AdminPageHeader";
import EmptyState from "@/components/common/EmptyState";
import { SCREENS } from "@/constants/testIds";

/**
 * La entrada al módulo Reportes aparece deshabilitada en el sidebar.
 * Esta pantalla existe únicamente para la ruta `/admin/reportes` accedida
 * directamente (por URL). Muestra el estado "Próximamente".
 */
export default function AdminReportes() {
  return (
    <div data-testid={SCREENS.adminReportes} className="flex flex-col gap-10">
      <AdminPageHeader
        eyebrow="Portal administrativo"
        title="Reportes"
        description="Reportes ejecutivos y estadísticas del club."
      />
      <EmptyState
        icon={BarChart3}
        eyebrow="Próximamente"
        title="Módulo en preparación"
        description="Los reportes se habilitarán cuando los módulos de datos estén activos."
        testId="empty-admin-reportes"
      />
    </div>
  );
}
